<template>
    <div class="note">
        <label>{{text}}</label>
    </div>
</template>

<script>
    export default {
        name: "Note",
        props: {
            text: String
        }
    }
</script>

<style scoped>
    .note {
        display: inline-block;
        margin: 5px auto;
        padding: 0 10px;
        font-size: 13px;
        background-color: #fef0f0;
        border-color: #fde2e2;
        color: #f56c6c;
        border-radius: 5px;
        box-sizing: border-box;
    }
</style>
